import { InternalVerificationIssueBM } from '../../types/BusinessModel/Verification/InternalVerificationIssueBM';
import { InternalVerificationIssue } from '../../types/ViewModel/Verification/InternalVerificationIssue';

export const createInternalIssue = (internalIssue: InternalVerificationIssueBM): InternalVerificationIssue => {
    return {
        dnvReportId: internalIssue.dnvReportId,
        imoNumber: internalIssue.imoNumber,
        issueId: internalIssue.issueId,
        typeId: internalIssue.typeId,
        details: internalIssue.details,
        issueDateTimeLocalFrom: internalIssue.issueDateTimeLocalFrom,
        issueDateTimeLocalTo: internalIssue.issueDateTimeLocalTo,
        issueDateTimeUTCFrom: internalIssue.issueDateTimeUTCFrom,
        issueDateTimeUTCTo: internalIssue.issueDateTimeUTCTo,
        accepted: internalIssue.accepted,
        acceptedAt: internalIssue.acceptedAt,
        acceptedByUser: internalIssue.acceptedByUser,
    };
};

export const createInternalIssuesList = (dnvIssueList: InternalVerificationIssueBM[]) => dnvIssueList?.map((issue) => createInternalIssue(issue));
